export class DataTableOption {
  itemsPerPage: number;
  page: number;

  constructor() {
    this.itemsPerPage = 10;
    this.page = 1;
  }
}
